import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '20px'
  },

  iconButtonBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  },

  iconButton: {
    cursor: 'pointer'
  },

  sendBlock: {
    display: 'flex',
    alignItems: 'center'
  },

  cannedButton: {
    display: 'grid',
    placeItems: 'center',
    marginRight: '8px',
    borderRadius: '6px',
    padding: '5px',
    background: '#b5b5b5',
    cursor: 'default',
    width: theme.size.base,
    height: theme.size.base
  },

  sendButton: {
    display: 'flex',
    alignItems: 'center',
    marginRight: ({ isPrivate }) => (isPrivate ? '0' : '4px'),
    borderRadius: '100rem',
    padding: '7px 12px',
    background: ({ canSend }) =>
      canSend ? theme.palette.primary.main : '#b5b5b5',
    cursor: ({ canSend }) => (canSend ? 'pointer' : 'default'),
    fontSize: theme.size.base,
    color: 'white',

    '& .icon': {
      marginLeft: '4px'
    }
  }
}))

export default useStyles
